export function getDependencyConfigKeys(configTree, stepEvent) {
    var _a;
    var keys = [];
    for (var _i = 0, _b = Array.from(configTree.entries()); _i < _b.length; _i++) {
        var _c = _b[_i], key = _c[0], value = _c[1];
        if (!value.config.needs)
            continue;
        if (((_a = value.config.needs) === null || _a === void 0 ? void 0 : _a.name) === stepEvent.stepName && value.config.needs.event === stepEvent.event) {
            keys.push(key);
        }
    }
    return keys;
}
//# sourceMappingURL=getDependencyConfigKeys.js.map